// removed by extract-text-webpack-plugin
module.exports = {"saveSearchModalContent":"sRBcIjxK2ATb-k_pVnut"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DetailsToInvoiceVRPhoto/VRPhotoInvoiceModal.scss
// module id = 1805
// module chunks = 0